import { getAuthToken, getUserData } from './user';
import {
    LOAD_BIDDER_DATA_SUCCESS,
    LOG_OUT_BIDDER,
    SEND_RESELLER_TYPE_FAIL,
    SEND_RESELLER_TYPE_REQUEST,
    SEND_RESELLER_TYPE_SUCCESS,
} from './actions';
import { ActionWithPayload } from '@/types/redux';
import api from '@/redux/api/reseller';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { getLoginAnalytics } from './analytics';
import { handleActions } from 'redux-actions';
import { LOGIN_SUCCESS } from './login';
import resellerTypes from '@/enums/resellerTypes';

// reducer
const DEFAULT_STATE = {
    error: false,
    loaded: 0,
    loading: false,
    resellerSelection: undefined,
};

type State = typeof DEFAULT_STATE;

export const reducer = handleActions(
    {
        [LOAD_BIDDER_DATA_SUCCESS]: (state: State, action: any) => ({
            ...state,
            loaded: action.meta.actionTime,
            loading: false,
            resellerSelection: action.payload.resellerType,
        }),
        [LOG_OUT_BIDDER]: () => ({
            ...DEFAULT_STATE,
        }),
        [LOGIN_SUCCESS]: (state: State, action: any) => ({
            ...state,
            loaded: action.meta.actionTime,
            loading: false,
            resellerSelection: action.payload.resellerType,
        }),
        [SEND_RESELLER_TYPE_FAIL]: (state: State, action: ActionWithPayload<{ error: string }>) => ({
            ...state,
            error: action.error,
            loading: false,
        }),
        [SEND_RESELLER_TYPE_REQUEST]: (state: State) => ({
            ...state,
            loading: true,
        }),
        [SEND_RESELLER_TYPE_SUCCESS]: (state: State, action: any) => ({
            ...state,
            loading: false,
            resellerSelection: action.payload.resellerType,
        }),
    },
    DEFAULT_STATE
);

/* SELECTORS */
const stateSelector = (state) => state.reseller;

export const getResellerType = createSelector(stateSelector, (state) => state.resellerSelection);

export const getIsReseller = createSelector(
    stateSelector,
    (state) => state.resellerSelection === resellerTypes.RESELLER
);

/* ACTION CREATORS */

export const sendResellerType = (resellerSelection: number) => async (dispatch: Function, getState: Function) => {
    try {
        dispatch({
            type: SEND_RESELLER_TYPE_REQUEST,
        });
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const userData = getUserData(state);
        const resellerType = resellerSelection ? resellerTypes.RESELLER : resellerTypes.NOT_A_RESELLER;

        const response = await api.postResellerType({
            authToken,
            bidderId: userData.bidderId,
            deployment,
            resellerType,
        });

        const analytics = getLoginAnalytics(userData, resellerType);
        return dispatch({
            meta: { analytics: analytics.analytics },
            payload: { message: response.payload, resellerType },
            type: SEND_RESELLER_TYPE_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error.message || error,
            type: SEND_RESELLER_TYPE_FAIL,
        });
    }
};
